import axios from "../../plugins/axios";

const apiEndpoints = {
  namespaced: true,

  state: {},

  mutations: {},

  actions: {
    // apiEndpoint
    async apiEndpoint({ rootState }, reqData = { endpoint: "", bodyData: {} }) {
      var response = {
        status: 500,
        data: {
          message: "Internal Server Error!!",
        },
      };

      var endpoint = reqData.endpoint;
      var bodyData = reqData.bodyData;

      bodyData.session_key = rootState.auth.session_key;
      bodyData.idnumber = rootState.auth.idnumber;

      try {
        const res = await axios.post(endpoint, bodyData);

        response.status = res.status;
        response.data = res.data;
      } catch (error) {
        if (error && error.response && error.response.status) {
          response.status = error.response.status;
        }

        if (error && error.response && error.response.data) {
          response.data = error.response.data;
        }
      }

      return response;
    },
  },

  getters: {},
};

export default apiEndpoints;
